import React from "react";
import styles from "./LocalAdventuresSection.module.css";
import { highlightGoldCoast } from "../../../utils/highlightGoldCoast";

const LocalAdventuresSection = () => {
  return (
    <section className={styles.section} aria-label="Local Adventures">
      <div className={styles.grid}>
        <div
          className={styles.visual}
          style={{ backgroundImage: 'url("/images/ARB. 3.jpg")' }}
          role="img"
          aria-label="Arabella Motor Inn reception"
        />
        <div className={styles.copy}>
          <h2>Local Adventures</h2>
          <p>
            {highlightGoldCoast(
              "Modern comfort in local hospitality. We are located at the heart of Tweed Heads, providing you with the best of both worlds. Explore delightful local cafes, surf spots, and much more."
            )}
          </p>
          <p>
            {highlightGoldCoast(
              "Our team is dedicated to making your coastal escape truly memorable with personalized recommendations and authentic local soul. The property is non-smoking, with daily room service and a team that can help with local Tweed Heads South, NSW directions."
            )}
          </p>
          <p>
            {highlightGoldCoast(
              "Whether the stay is a night between flights, a family visit, or a few days on the coast, this Tweed Heads motel keeps the focus on a well-kept room and an easy Tweed Heads South, NSW location near Murwillumbah and the Northern Rivers."
            )}
          </p>
        </div>
      </div>
    </section>
  );
};

export default LocalAdventuresSection;
